import { Resource } from "../resource"

export class Project extends Resource{
    name: string | any
    description: string | any
    created: Date | any
} 